import React, { useState } from 'react';
import { companyInfo } from '../data/mock';
import { Menu, X, Languages } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { language, toggleLanguage } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const t = (key) => getTranslation(language, key);

  return (
    <header className="dark-header">
      <div className="dark-logo-container">
        <img 
          src="/logo.jpeg" 
          alt={companyInfo.name}
          className="company-logo"
        />
      </div>

      {/* Desktop Navigation */}
      <nav className="dark-nav">
        <button onClick={() => scrollToSection('home')} className="dark-nav-link">
          {t('nav.home')}
        </button>
        <button onClick={() => scrollToSection('services')} className="dark-nav-link">
          {t('nav.services')}
        </button>
        <button onClick={() => scrollToSection('about')} className="dark-nav-link">
          {t('nav.about')}
        </button>
        <button onClick={() => scrollToSection('contact')} className="dark-nav-link">
          {t('nav.contact')}
        </button>
        <button 
          onClick={toggleLanguage} 
          className="language-switcher"
          title={language === 'en' ? 'التبديل إلى العربية' : 'Switch to English'}
        >
          <Languages size={20} />
          <span>{language === 'en' ? 'AR' : 'EN'}</span>
        </button>
        <button onClick={() => scrollToSection('contact')} className="btn-primary">
          {t('nav.getInTouch')}
        </button>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <button onClick={() => scrollToSection('home')} className="mobile-nav-link">
            {t('nav.home')}
          </button>
          <button onClick={() => scrollToSection('services')} className="mobile-nav-link">
            {t('nav.services')}
          </button>
          <button onClick={() => scrollToSection('about')} className="mobile-nav-link">
            {t('nav.about')}
          </button>
          <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">
            {t('nav.contact')}
          </button>
          <button 
            onClick={toggleLanguage} 
            className="mobile-nav-link language-mobile"
          >
            <Languages size={20} />
            <span>{language === 'en' ? 'العربية' : 'English'}</span>
          </button>
          <button onClick={() => scrollToSection('contact')} className="btn-primary" style={{ width: '100%' }}>
            {t('nav.getInTouch')}
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
